import {
	Component,
	ChangeDetectionStrategy,
	OnInit,
} from '@angular/core';
import { SeoService } from 'app/services/seo.service';


@Component({
	selector: 'home',
	templateUrl: '../templates/home.pug',
	styleUrls: ['../styles/home.scss'],
	host: { class: 'home' },
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomeComponent implements OnInit {

	constructor(
		private _seo: SeoService
	) {}

	ngOnInit() {
		this._seo.setTitle('Thực Phẩm Đồng Quê - Trang Chủ');
		this._seo.updateTags([
			{ name: 'description', content: 'Trang chủ Đồng Quê - Thực phẩm tươi sống, sạch và an toàn tại Quy Nhơn, Gia Lai.' },
			{ name: 'keywords', content: 'thực phẩm sạch, rau củ, thịt tươi, hải sản, Quy Nhơn, Gia Lai' },
			{ property: 'og:title', content: 'Thực Phẩm Đồng Quê - Trang Chủ' },
			{ property: 'og:description', content: 'Thực phẩm tươi sống, sạch và an toàn tại Quy Nhơn, Gia Lai.' }
		]);
		this._seo.setLink();
	}
}
